module.exports = __webpack_public_path__ + "img/plug-right.18e299ec.svg";